var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rating-grades"},_vm._l((_vm.grades),function(item){return _c('grade-item',{key:item.id,attrs:{"item":item,"current-value":_vm.currentRating},on:{"updateGrade":_vm.updateGrade}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }